import {
  Col,
  Layout,
  Row,
  Typography,
  Tabs,
  Skeleton,
  Tag,
  Avatar,
  Slider,
  Menu,
} from "antd";
import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import Header from "../Authorized/Header";
import constants from "../Redux/constants";
import {
  getOfferComments,
  getOfferProgress,
  addNewComment,
  getFilterComments,
  getInnerComments,
  updateComment,
} from "../Redux/User/reducer";
import Feedback from "../Utilities/Feedback";
import { LoadingOutlined, MoreOutlined } from "@ant-design/icons";
import { CancelButton, StyledLink } from "../styled-components/components";
import { Formik } from "formik";
import { Form } from "formik-antd";
import { FormikSelect, FormikSubmitButton, FormikTextArea } from "../FormItems";
import FileUpload from "../Utilities/FileUpload";
import * as Yup from "yup";
import commentTypes from "../../data/commentTypes.json";
import moment from "moment";
import { Helmet } from "react-helmet";

const ViewProgress = (props) => {
  const jobId = props.match.params.jobId;
  const offerId = props.match.params.offerId;
  const {
    getOfferDetail,
    fetchOfferComments,
    addComment,
    getFilterComments,
    fetchInnerComments,
    updateComment,
  } = props;
  const [loadingOfferDetail, setOfferLoading] = useState(true);
  const [loadingComments, setLoadingComments] = useState(true);
  const [loadNewComment, setLoadNewComment] = useState(false);
  // get offer detail, comments
  useEffect(() => {
    const getJobDetail = async () => {
      await getOfferDetail(jobId);
    };
    const getComments = async () => {
      await fetchOfferComments(offerId);
      setOfferLoading(false);
    };
    getJobDetail();
    getComments();
  }, [jobId, offerId, getOfferDetail, fetchOfferComments]);
  const { jobDetail, uploadedFiles, allOfferComments } = useSelector(
    (state) => state.userStore
  );
  // comment parentProgressId is null
  const initialValues = {
    addComment: "",
    commentType: "",
    percentageCompletion: "",
    fileIds: "",
  };
  const validationSchema = Yup.object({
    addComment: Yup.string().required("Comment is required"),
    commentType: Yup.string().required("Comment Type is required"),
  });
  // add a new comment
  const addNewComment = async (values) => {
    setLoadNewComment(true);
    const { commentType, percentageCompletion } = values;
    values.fileIds = uploadedFiles;
    const clarificationStatus =
      commentType === constants.commentTypes.clarification
        ? constants.clarificationStatus.open
        : null;
    const { responseStatus } = await addComment(
      offerId,
      values.addComment,
      commentType,
      null,
      clarificationStatus,
      percentageCompletion,
      values.fileIds
    );
    if (responseStatus === constants.status.created) {
      setLoadNewComment(false);
    }
  };
  // update comment: add a reply
  const updateComments = async (offerId, reply, commentType, progressId) => {
    setLoadingComments(false);
    const { responseStatus } = await addComment(
      offerId,
      reply,
      commentType,
      progressId,
      null,
      null,
      uploadedFiles
    );
    if (responseStatus === constants.status.created) {
      setLoadingComments(true);
    }
  };
  // update status of comment
  const updateCommentStatus = async (commentDetail) => {
    const { progressId, completionPercentage, commentText } = commentDetail;
    const fileIds = commentDetail.attachments.map((each) => each.fileId);
    console.log(progressId);
    await updateComment(
      offerId,
      progressId,
      commentText,
      constants.clarificationStatus.close,
      completionPercentage,
      fileIds
    );
  };
  return (
    <Layout>
      <Helmet title={`Progress ${jobDetail.title} | Unicon`} />
      <Header></Header>
      <Layout.Content>
        <Col
          lg={{ span: 20 }}
          xl={{ span: 16 }}
          style={{
            padding: "2vh",
            background: "#ffffff",
            border: "1px solid #f4f4f4",
            margin: "2vh",
            marginLeft: "auto",
            marginRight: "auto",
            borderRadius: "4px",
          }}
        >
          {loadingOfferDetail ? (
            <Feedback title="Fetching Progress..." icon={<LoadingOutlined />} />
          ) : (
            <Col>
              <Col xl={{ span: 10 }}>
                <Row justify="space-between">
                  <Col>
                    <Typography.Title level={4}>
                      {jobDetail.title}
                    </Typography.Title>
                  </Col>
                </Row>
                <Row justify="space-between">
                  <Col>
                    Start Date:
                    {jobDetail.targetStartDate}
                  </Col>
                  <Col>
                    End Date:
                    {jobDetail.targetEndDate}
                  </Col>
                </Row>
                <Row justify="space-between">
                  <Col>
                    Additional Details:
                    <Row>
                      {jobDetail.additionalComments ? (
                        <Col>{jobDetail.additionalComments}</Col>
                      ) : null}
                    </Row>
                  </Col>
                  {/* <Col>
                    Attachments:
                    <Row>
                      {jobDetail.attachments}
                    </Row>
                  </Col> */}
                </Row>
              </Col>
              <Row style={{ marginTop: "2vh" }}>
                <Typography.Title level={5}>Activity</Typography.Title>
              </Row>
              <Col>
                {loadNewComment ? (
                  <Feedback
                    icon={<LoadingOutlined />}
                    title="Adding comment"
                  ></Feedback>
                ) : (
                  <Col style={{ marginTop: "2vh" }}>
                    <FormikComment
                      initialValues={initialValues}
                      validationSchema={validationSchema}
                      addNewComment={addNewComment}
                      showCommentType={true}
                    />
                  </Col>
                )}
              </Col>
              {!loadingComments ? (
                <Feedback
                  title="Updating Comments"
                  icon={<LoadingOutlined />}
                ></Feedback>
              ) : (
                <Col>
                  <Comments
                    offerId={offerId}
                    getFilterComments={getFilterComments}
                    allComments={allOfferComments}
                    updateComments={updateComments}
                    showTabs={true}
                    fetchInnerComments={fetchInnerComments}
                    updateCommentStatus={updateCommentStatus}
                  ></Comments>
                </Col>
              )}
            </Col>
          )}
        </Col>
      </Layout.Content>
    </Layout>
  );
};

const FormikComment = (props) => {
  const [showProgress, setShowProgress] = useState(false);
  const [percentageCompletion, setCompletion] = useState("");
  const getType = (value) => {
    if (value === constants.commentTypes.standard) {
      setShowProgress(true);
    } else {
      setShowProgress(false);
    }
  };
  const getValue = (value) => {
    setCompletion(value);
  };
  const onSubmit = (values) => {
    values.percentageCompletion = percentageCompletion;
    props.addNewComment(values);
  };
  return (
    <Formik
      initialValues={props.initialValues}
      validationSchema={props.validationSchema}
      validateOnMount
      onSubmit={onSubmit}
    >
      {(formik) => {
        return (
          <Form>
            <Row justify="space-between">
              <Col xl={{ span: 8 }}>
                {props.showCommentType ? (
                  <FormikSelect
                    id="commentType"
                    name="commentType"
                    callBack={true}
                    getStatus={getType}
                    placeholder="Select Comment Type"
                    options={commentTypes}
                  />
                ) : null}
                {showProgress ? (
                  <Col>
                    <Typography.Text>Percentage Completion</Typography.Text>
                    <Slider
                      data-testid="slider"
                      value={percentageCompletion}
                      onChange={getValue}
                    ></Slider>
                  </Col>
                ) : null}
              </Col>
              <Col xl={{ span: 12 }}>
                <FormikTextArea
                  id="newComment"
                  placeholder="Add a new comment"
                  name="addComment"
                />
              </Col>
            </Row>
            <Row justify="space-between" align="middle">
              <Col xl={{ span: 10 }}>
                <FileUpload id="upload-screenshot" name="fileIds" />
              </Col>
              <Col xl={{ span: 6 }}>
                <FormikSubmitButton
                  id="submit-progress"
                  disabled={!formik.isValid}
                  name="Save"
                />
              </Col>
            </Row>
          </Form>
        );
      }}
    </Formik>
  );
};

const FormikReply = (props) => {
  const onSubmit = (values) => {
    props.addNewComment(values);
  };
  const hideReply = () => {
    props.hideReply();
  };
  return (
    <Formik
      initialValues={props.initialValues}
      validationSchema={props.validationSchema}
      validateOnMount
      onSubmit={onSubmit}
    >
      {(formik) => {
        return (
          <Form>
            <Row align="middle">
              <Col style={{ margin: "1vh" }} flex={2}>
                <Typography.Text>Reply</Typography.Text>
                <FormikTextArea
                  placeholder="Enter reply here..."
                  name="addComment"
                />
              </Col>
              <Col style={{ margin: "1vh" }} flex={2}>
                <FileUpload name="fileIds" />
              </Col>
              <Col style={{ margin: "1vh", marginTop: "4vh" }} flex={1}>
                <FormikSubmitButton disabled={!formik.isValid} name="Save" />
              </Col>
              <Col style={{ margin: "1vh", marginTop: "4vh" }}>
                <CancelButton onClick={hideReply}>Cancel</CancelButton>
              </Col>
            </Row>
          </Form>
        );
      }}
    </Formik>
  );
};

const Comments = (props) => {
  const [filteredComments, setFilteredComments] = useState([]);
  const [showFilterComments, setShowFilterComments] = useState(false);
  const [loading, setLoading] = useState(false);
  const [clarificationDisabled, setClarificationDisabled] = useState(false);
  const [standardDisabled, setStandardDisabled] = useState(false);
  const [type, setType] = useState("");
  const {
    allComments,
    updateComments,
    getFilterComments,
    fetchInnerComments,
    updateCommentStatus,
  } = props;

  // get filter comments
  const getFilteredComments = async (commentType) => {
    if (commentType === "ALL") {
      setShowFilterComments(false);
    } else {
      setLoading(true);
      setType(commentType);
      if (commentType === constants.commentTypes.standard) {
        setClarificationDisabled(true);
      }
      if (commentType === constants.commentTypes.clarification) {
        setStandardDisabled(true);
      }
      setFilteredComments([]);
      setShowFilterComments(true);
      const { filterComments } = await getFilterComments(
        props.offerId,
        commentType
      );
      setFilteredComments([...filterComments]);
      setStandardDisabled(false);
      setClarificationDisabled(false);
      setLoading(false);
    }
  };
  const closeStatusDetails = async (commentId) => {
    const commentDetail = allComments.filter(
      (cmt) => cmt.progressId === commentId
    );
    await updateCommentStatus(commentDetail[0]);
  };
  return (
    <Col style={{ margin: "auto", marginTop: "3vh" }} xl={{ span: 22 }}>
      {props.showTabs ? (
        <Row style={{ margin: "2vh" }}>
          <Tabs type="card" onChange={getFilteredComments}>
            <Tabs.TabPane tab="ALL" key="ALL"></Tabs.TabPane>
            <Tabs.TabPane
              disabled={standardDisabled}
              tab={constants.commentTypes.standard}
              key={constants.commentTypes.standard}
            ></Tabs.TabPane>
            <Tabs.TabPane
              disabled={clarificationDisabled}
              tab={constants.commentTypes.clarification}
              key={constants.commentTypes.clarification}
            ></Tabs.TabPane>
          </Tabs>
        </Row>
      ) : null}

      {allComments.length > 0 ? (
        <Col>
          {showFilterComments ? (
            <Col>
              {loading ? (
                <Col>
                  <Skeleton active />
                </Col>
              ) : (
                <Col>
                  {filteredComments.length > 0 ? (
                    <Col>
                      <CommentCard
                        comments={filteredComments}
                        updateComments={updateComments}
                        fetchInnerComments={fetchInnerComments}
                        closeStatusDetails={closeStatusDetails}
                      />
                    </Col>
                  ) : (
                    <Col>
                      <Typography.Text>
                        No Comments Found for {type}
                      </Typography.Text>
                    </Col>
                  )}
                </Col>
              )}
            </Col>
          ) : (
            <Col xl={{ span: 20 }}>
              <CommentCard
                comments={allComments}
                updateComments={updateComments}
                fetchInnerComments={fetchInnerComments}
                closeStatusDetails={closeStatusDetails}
              />
            </Col>
          )}
        </Col>
      ) : (
        <Col>No Comments</Col>
      )}
    </Col>
  );
};

const CommentCard = ({
  comments,
  updateComments,
  fetchInnerComments,
  closeStatusDetails,
}) => {
  const closeStatus = (commentId) => {
    closeStatusDetails(commentId);
  };
  // tag color
  const getColor = (commentType) =>
    commentType === constants.commentTypes.clarification ? "error" : "blue";
  return (
    <Col>
      {comments.map((comment) => (
        <Col
          key={comment.progressId}
          style={{
            marginBottom: "2vh",
            borderBottom: "1px solid #9C9C9C",
          }}
        >
          <Row justify="space-between" align="middle">
            <Col>
              <Row justify="space-between">
                <Col style={{ marginLeft: "1vh", marginRight: "1vh" }}>
                  <Avatar size="large" style={{ backgroundColor: "#90caf9" }}>
                    {comment.firstName[0]}
                  </Avatar>
                </Col>
                <Col style={{ marginLeft: "1vh", marginRight: "1vh" }}>
                  {comment.firstName}
                </Col>

                <Col style={{ marginLeft: "1vh", marginRight: "1vh" }}>
                  {moment
                    .utc(comment.createdDate)
                    .local()
                    .format("YYYY/MM/DD LT")}
                </Col>
                <Col style={{ marginLeft: "1vh", marginRight: "1vh" }}>
                  <Tag color={getColor(comment.commentType)}>
                    {comment.commentType}
                  </Tag>
                </Col>
                {comment.clarificationStatus ? (
                  <Col style={{ marginLeft: "1vh", marginRight: "1vh" }}>
                    <Tag color="#1565d8">{comment.clarificationStatus}</Tag>
                  </Col>
                ) : null}
              </Row>
            </Col>
            <Col style={{ marginLeft: "1vh", marginRight: "1vh" }}>
              {!comment.clarificationStatus ? null : (
                <Col>
                  <Menu mode="horizontal">
                    <Menu.SubMenu title={<MoreOutlined />}>
                      <Menu.Item
                        onClick={() => closeStatus(comment.progressId)}
                      >
                        Close Status
                      </Menu.Item>
                    </Menu.SubMenu>
                  </Menu>
                </Col>
              )}
            </Col>
          </Row>
          <Row style={{ marginLeft: "8vh" }}>
            <Col>{comment.commentText}</Col>
          </Row>
          <Row style={{ marginLeft: "8vh", marginTop: "2vh" }}>
            <Col>
              {comment.attachments.length > 0 ? (
                <Col>
                  <Row>
                    <Typography.Title level={5}>Attachments:</Typography.Title>
                  </Row>
                  <Row>
                    {comment.attachments.map((file) => (
                      <Col key={file.fileUrl} style={{ margin: "1vh" }}>
                        <StyledLink>{file.fileName}</StyledLink>
                      </Col>
                    ))}
                  </Row>
                </Col>
              ) : null}
            </Col>
          </Row>
          <Actions
            repliesCount={comment.commentCount}
            offerId={comment.offerId}
            progressId={comment.progressId}
            updateComments={updateComments}
            fetchInnerComments={fetchInnerComments}
          />
        </Col>
      ))}
    </Col>
  );
};

// update comments will add new replies....
const Actions = ({
  repliesCount,
  offerId,
  progressId,
  updateComments,
  fetchInnerComments,
}) => {
  // comment for parentProgressId
  const initialValues = {
    addComment: "",
    fileIds: "",
  };
  const validationSchema = Yup.object({
    addComment: Yup.string().required("Comment is required"),
  });
  const [replyBox, setReplyBox] = useState(false);
  const [showReplies, setShowReplies] = useState(false);
  const [innerComments, setInnerComments] = useState([]);
  const addReply = async (values) => {
    const commentType = constants.commentTypes.comment;
    await updateComments(offerId, values.addComment, commentType, progressId);
    setReplyBox(false);
  };
  const getReplies = async () => {
    setInnerComments([]);
    const getInnerComments = await fetchInnerComments(offerId, progressId);
    setInnerComments([...getInnerComments]);
    setShowReplies(true);
  };
  const hideReply = () => {
    setReplyBox(false);
  };
  return (
    <Col>
      <Col xl={{ span: 10 }} style={{ marginTop: "1vh", marginBottom: "2vh" }}>
        <Row justify="space-between">
          <Col>
            {repliesCount > 0 ? (
              <Col>
                {showReplies ? (
                  <StyledLink
                    data-testid="submit-hideReplies"
                    onClick={() => setShowReplies(false)}
                  >
                    Hide Replies({repliesCount})
                  </StyledLink>
                ) : (
                  <StyledLink
                    onClick={getReplies}
                    data-testid="submit-viewReplies"
                  >
                    View Replies({repliesCount})
                  </StyledLink>
                )}
              </Col>
            ) : null}
          </Col>
          {!replyBox ? (
            <Col>
              <StyledLink
                data-testid="showReplyBox"
                onClick={() => setReplyBox(true)}
              >
                Reply
              </StyledLink>
            </Col>
          ) : null}
        </Row>
      </Col>
      {replyBox ? (
        <Col xl={{ span: 24 }}>
          <FormikReply
            initialValues={initialValues}
            validationSchema={validationSchema}
            addNewComment={addReply}
            showCommentType={false}
            hideReply={hideReply}
          />
        </Col>
      ) : null}
      {showReplies ? (
        <Comments showTabs={false} allComments={innerComments} />
      ) : null}
    </Col>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getOfferDetail: (jobId) => dispatch(getOfferProgress(jobId)),
    fetchOfferComments: (offerId) => dispatch(getOfferComments(offerId)),
    addComment: (
      offerId,
      comment,
      commentType,
      progressParentId,
      clarrificationStatus,
      percentageCompletion,
      fileIds
    ) =>
      dispatch(
        addNewComment(
          offerId,
          comment,
          commentType,
          progressParentId,
          clarrificationStatus,
          percentageCompletion,
          fileIds
        )
      ),
    getFilterComments: (offerId, commentType) =>
      dispatch(getFilterComments(offerId, commentType)),
    fetchInnerComments: (offerId, progressId) =>
      dispatch(getInnerComments(offerId, progressId)),
    updateComment: (
      offerId,
      progressId,
      comment,
      clarificationStatus,
      percentageCompletion,
      fileIds
    ) =>
      dispatch(
        updateComment(
          offerId,
          progressId,
          comment,
          clarificationStatus,
          percentageCompletion,
          fileIds
        )
      ),
  };
};

export default connect(null, mapDispatchToProps)(ViewProgress);
